// extracted by mini-css-extract-plugin
export default {"form":"SearchForm_form__abNqo","input":"SearchForm_input__QXIPX"};